<div
  class="patient-overview-frame"
  [class.fullscreen]="vm.isImageShareMode">
  <app-window-title
    [closable]="true"
    [title]="'Patient Overview'"
    (closed)="onClose()"></app-window-title>

  <!-- Shared controls template -->
  <ng-template #controlStack>
    <app-transfer-visualization
      [destinationFacility]="selectedFacility"
      [exchangeMode]="exchangeMode"
      [facilitator]="selectedFacilitator"
      [sourceFacility]="sourceFacility">
    </app-transfer-visualization>

    <app-exchanger-switch
      style="height: 250px"
      (optionChange)="onOptionChange($event)"
      (valueChange)="onValueChange($event)"></app-exchanger-switch>
  </ng-template>

  <div
    class="patient-info-section"
    [class.split-mode]="vm.isImageShareMode">
    <div class="patient-info-left">
      <!-- Basic patient information -->
      <app-patient-basic-info
        [compact]="vm.isImageShareMode"
        [patient]="vm.patient">
      </app-patient-basic-info>

      <!-- Fullscreen-left controls -->
      <div
        *ngIf="vm.isImageShareMode"
        class="fullscreen-left-controls">
        <ng-container *ngTemplateOutlet="controlStack"></ng-container>
      </div>
    </div>

    <div
      *ngIf="!vm.isImageShareMode"
      class="patient-info-right">
      <div class="patient-picture-section">
        <div class="picture-placeholder">
          <img
            *ngIf="vm.patient?.patientPicture"
            class="patient-image"
            alt="Patient Picture"
            [src]="vm.patient.patientPicture" />
          <div
            *ngIf="!vm.patient?.patientPicture"
            class="no-image">
            <mat-icon> person </mat-icon>
            <span> PATIENT PICTURE </span>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="vm.isImageShareMode"
      #imageShareRight
      class="image-share-right">
      <div
        *ngIf="activeImageShareTitle"
        class="image-share-header">
        {{ activeImageShareTitle }}
      </div>
      <div class="image-share-iframe-container">
        <div
          *ngIf="vm.isIframeLoading"
          class="iframe-loading">
          Loading...
        </div>
        <iframe
          *ngIf="vm.selectedImageShareUrl"
          class="image-share-frame"
          frameborder="0"
          [src]="vm.selectedImageShareUrl | safe"
          [title]="activeImageShareTitle"
          (load)="onIframeLoaded()"></iframe>
      </div>
    </div>
  </div>
</div>

<!-- Default placement when not in fullscreen mode -->
<ng-container *ngIf="!vm.isImageShareMode">
  <ng-container *ngTemplateOutlet="controlStack"></ng-container>
</ng-container>
